// constants
import { showSuccessAlert } from "../../constants/alerts";
import { RevenueActionTypes } from "./constants";

const INIT_STATE = {
  payments: [],
  insights: [],
  totals: [],
  orders: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface CategoryActionType {
  type:
    | RevenueActionTypes.API_RESPONSE_SUCCESS
    | RevenueActionTypes.API_RESPONSE_ERROR
    | RevenueActionTypes.GET_REVENUE;

  payload: {
    actionType?: string;
    data?: any;
    error?: string;
    payments?: [];
  };
}

const Revenue = (state: any = INIT_STATE, action: CategoryActionType): any => {
  switch (action.type) {
    case RevenueActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case RevenueActionTypes.GET_REVENUE: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            payments: action.payload.data.payments,
            insights: action.payload.data.enrolledUsersPerCourse,
            totals: action.payload.data.totals,
            orders: action.payload.data.orders,
          };
        }
        default:
          return { ...state };
      }

    case RevenueActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case RevenueActionTypes.GET_REVENUE: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }

        default:
          return { ...state };
      }

    case RevenueActionTypes.GET_REVENUE:
      return { ...state, loading: true, initialLoading: true };
    default:
      return { ...state };
  }
};

export default Revenue;
